module.exports = __webpack_public_path__ + "img/keyboard_arrow_left-24px.9cdf3940.svg";